import { useRef } from 'react';
import { useProjectionPaint } from '../hooks/projectionPaint.hook.js';

/** The existing page supplies its rendered score; this component adds observation only. */
export function ProjectionScore({ observer, row, text, className }) {
  const element = useRef(null);
  useProjectionPaint(observer, row, text, element);
  const attestation = observer?.attestation?.();
  return <span ref={element} className={className} data-observer-session={attestation?.session}
    data-observer-build={attestation?.build} data-observer-negotiation={attestation ? observer.negotiation : undefined}
    data-observer-diagnostics={attestation ? JSON.stringify(observer.diagnostics()) : undefined}>{text}</span>;
}
